import * as React from "react";
import { List } from "react-admin";
import { DefaultPerPageSize } from "../../../Constants/Constant";
import SubListGridColumns from "./SubListGridColumns";

export const SubList = props => {
  const { record, ...rest } = props;

  return (
    <List
      {...props}
      title={"Shop Report"}
      hasCreate={false}
      exporter={false}
      resource={"shopreports"}
      basePath={"shopreports"}
      hasBulkActions={false}
      perPage={DefaultPerPageSize}
      filterDefaultValues={{
        wo__eq: record?.wo?.toString?.(),
      }}
    >
      <SubListGridColumns {...rest} />
    </List>
  );
};

export default SubList;
